import { render, staticRenderFns } from "./Answering.vue?vue&type=template&id=f6be9f60&scoped=true"
import script from "./Answering.vue?vue&type=script&lang=js"
export * from "./Answering.vue?vue&type=script&lang=js"
import style0 from "./Answering.vue?vue&type=style&index=0&id=f6be9f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6be9f60",
  null
  
)

export default component.exports